import * as React from "react";
import { Controller, useForm } from "react-hook-form";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import { useState, useEffect } from "react";
import { getReport } from "src/apis/tickets";
import { getAllAssets, CreateBudget } from "src/apis/complex";
import { MenuItem, Select } from "@mui/material";
import TextField from "@mui/material/TextField";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Box from "@mui/material/Box";
import { CreateDeal, getAllDeals, getDeal, UpdateDeal } from "src/apis/deals";

import {
  DialogContent,
  DialogTitle,
  Grid,
  Switch,
  FormGroup,
  FormControlLabel,
} from "@mui/material";
import { useAlertContext } from "src/hooks/use-alert";
import "src/components/ReportHistory/budgetForm.css";
export default function DealForm({
  visbile,
  onClose,
  refreshControl,
  editSelectedDeal,
  editMode,
}) {
  const [otherIsSelected, setOtherIsSelected] = useState(null);
  const alert = useAlertContext();
  const financeData = [
    { id: 1, value: "Front" },
    { id: 2, value: "Back" },
    { id: 3, value: "Level" },

    // Add more finance types as needed
  ];
  const serviceData = [
    { id: 1, value: "Basic" },
    { id: 2, value: "Level 2" },
    { id: 3, value: "Level 3" },
    { id: 4, value: "Other" },
    // Add more service levels as needed
  ];

  const [multiline, setMultiline] = useState("");
  const {
    control,
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  {
    /** SubmitDeal api call  */
  }
  const SubmitDeal = async (data) => {
    console.log(data);
    try {
      var message;
      var response;
      if (!editMode) {
        response = await CreateDeal(data);
        message = "Deal created succesfully";
      } else if (editMode && editSelectedDeal) {
        data.id = editSelectedDeal.id;
        response = await UpdateDeal(data);
        message = "Deal updated succesfully";
      }
      onClose();
      if (response.success) {
        // success alert
        alert.setSuccess((prev) => [
          ...prev,
          {
            status: true,
            message: message,
            index: prev.length,
          },
        ]);
        refreshControl();
      } else {
        alert.setError((prev) => [
          ...prev,
          { status: true, messages: response.errors, index: prev.length },
        ]);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  useEffect(() => {
    console.log("other is selected !! ", otherIsSelected);
  }, [otherIsSelected]);
  return (
    <Dialog open={visbile} onClose={onClose}>
      <div className="FormContainer">
        <DialogTitle> Set up a Deal </DialogTitle>
        <DialogContent>
          <form>
            <div className="fieldswrapper">
              <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                {/**Input 1 : name */}
                <Grid item md={6} lg={6} sm={12}>
                  <div className="inline">Deal Name : </div>
                  <div className="inputContainers">
                    <input
                      type="text"
                      fullWidth
                      name="name"
                      {...register("name", { required: true })}
                    />
                  </div>
                </Grid>

                {/**Input 2 dropdown : Service */}
                <Grid item md={6} lg={6} sm={12}>
                  <form>
                    <div className="inline">Service:</div>
                    <div className="inputContainers">
                      <Controller
                        name="service"
                        control={control}
                        rules={{
                          required: "Please select a Project",
                        }}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <Select
                            sx={{
                              color: "white",
                              height: 37,
                              ".MuiOutlinedInput-notchedOutline": {
                                borderColor: "white",
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "white",
                              },
                              ".MuiSvgIcon-root ": {
                                fill: "white !important",
                              },
                            }}
                            value={value}
                            onChange={(e) => {
                              onChange(e);
                              // Check if the selected item has id 4
                              const selectedItem = serviceData.find(
                                (item) => item.value === e.target.value
                              );
                              if (selectedItem && selectedItem.id === 4) {
                                setOtherIsSelected(true);
                              } else {
                                setOtherIsSelected(false);
                              }
                            }}
                          >
                            {serviceData?.map((service) => (
                              <MenuItem
                                key={service.id}
                                value={service.value}
                                sx={{ border: "none" }}
                              >
                                {service.value}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      />
                    </div>
                  </form>
                </Grid>
                {/**Input   2a : Other */}
                { otherIsSelected &&
                (<Grid item md={6} lg={6} sm={12}>
                  <div className="inline">Specify other : </div>
                  <div className="inputContainers">
                    <input
                      type="text"
                      fullWidth
                      name="name"
                      style={{borderWidth:2,borderColor:'#4996ee'}}
                      {...register("other", { required: true })}
                    />
                  </div>
                </Grid>)
}

                {/**Input 3 Price: */}
                <Grid item md={6} lg={6} sm={12}>
                  <div className="inline">Price : € </div>
                  <div className="inputContainers">
                    <input
                      type="number"
                      fullWidth
                      name="price"
                      {...register("price", { required: true })}
                    />
                  </div>
                </Grid>

                {/**Input 4 dropdown : Finance*/}
                <Grid item md={6} lg={6} sm={12}>
                  <form>
                    <div className="inline">Finance:</div>
                    <div className="inputContainers">
                      <Controller
                        name="finance"
                        control={control}
                        rules={{
                          required: "Please choose a finance type",
                        }}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <Select
                            sx={{
                              color: "white",
                              height: 37,
                              ".MuiOutlinedInput-notchedOutline": {
                                borderColor: "white",
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "white",
                              },
                              ".MuiSvgIcon-root ": {
                                fill: "white !important",
                              },
                            }}
                            value={value}
                            onChange={onChange}
                          >
                            {financeData?.map((finance) => (
                              <MenuItem
                                key={finance.id}
                                value={finance.value}
                                sx={{ border: "none" }}
                              >
                                {finance.value}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      />
                    </div>
                  </form>
                </Grid>

                {/**Input 5 date : Enddate */}
                <Grid item md={6} lg={6} sm={12}>
                  <form>
                    <div className="inline">Start Date: </div>
                    <div className="inputContainers">
                      <Controller
                        name="start"
                        control={control}
                        rules={{
                          required: "Please select a Project",
                        }}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <DatePicker
                            selected={value}
                            onChange={onChange}
                            dateFormat="dd/MM/yyyy"
                          />
                        )}
                      />
                    </div>
                  </form>
                </Grid>

                {/**input 7 description */}
                <Grid item md={12} lg={12} sm={12}>
                  <div className="inlinetextarea">Description:</div>
                  <div className="inlinetextarea">
                    <TextField
                      multiline
                      value={multiline}
                      onChange={(e) => setMultiline(e.target.value)}
                    />
                  </div>
                </Grid>

                {/**Bottom part 1 for cancel button */}
                <Grid item xs={6} md={6}>
                  <div className="cancelBudgetProject">
                    <Button variant="text" onClick={onClose}>
                      Cancel
                    </Button>
                  </div>
                </Grid>

                {/**Bottom part 1 for submit button */}
                <Grid item xs={6} md={6}>
                  <div className="submitBudgetProject">
                    <Button variant="text" onClick={handleSubmit(SubmitDeal)}>
                      Submit
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </div>
          </form>
        </DialogContent>
      </div>
    </Dialog>
  );
}
